import { useEffect } from 'react';

const SITE = 'The Icing Calculator';

const setMeta = (selector, content) => {
  const el = document.querySelector(selector);
  if (el && content) el.setAttribute('content', content);
};

const getMeta = (selector) => document.querySelector(selector)?.getAttribute('content');

/**
 * Sets document.title and keeps og:/twitter: title, description, and url in sync
 * with the current route, so shared links show accurate social previews instead
 * of the same static homepage card for every page.
 */
const usePageTitle = (pageTitle, description) => {
  useEffect(() => {
    const fullTitle = pageTitle ? `${pageTitle} · ${SITE}` : SITE;
    document.title = fullTitle;

    const prevOgTitle = getMeta('meta[property="og:title"]');
    const prevOgDescription = getMeta('meta[property="og:description"]');
    const prevOgUrl = getMeta('meta[property="og:url"]');
    const prevTwitterTitle = getMeta('meta[name="twitter:title"]');
    const prevTwitterDescription = getMeta('meta[name="twitter:description"]');

    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[property="og:url"]', window.location.href);
    setMeta('meta[name="twitter:title"]', fullTitle);
    if (description) {
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }

    return () => {
      document.title = SITE;
      setMeta('meta[property="og:title"]', prevOgTitle);
      setMeta('meta[property="og:description"]', prevOgDescription);
      setMeta('meta[property="og:url"]', prevOgUrl);
      setMeta('meta[name="twitter:title"]', prevTwitterTitle);
      setMeta('meta[name="twitter:description"]', prevTwitterDescription);
    };
  }, [pageTitle, description]);
};

export default usePageTitle;
